var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.678,18.114h.824c1.179,0,2.134-.956,2.134-2.134V5.787c0-1.179-.956-2.134-2.134-2.134H7.498c-1.179,0-2.134.956-2.134,2.134v10.193c0,1.179.956,2.134,2.134,2.134h.824l-2.079,1.733c-.61.508-.25,1.501.543,1.501h0c.199,0,.391-.07.543-.197l3.644-3.037h2.054l3.644,3.037c.153.127.345.197.543.197h0c.794,0,1.153-.993.543-1.501l-2.079-1.733ZM8.192,16.656c-.67,0-1.213-.543-1.213-1.212s.543-1.213,1.213-1.213,1.213.543,1.213,1.213-.543,1.212-1.213,1.212ZM8.289,10.476c-.718,0-1.3-.582-1.3-1.3v-2.59c0-.718.582-1.3,1.3-1.3h7.44c.718,0,1.3.582,1.3,1.3v2.59c0,.718-.582,1.3-1.3,1.3h-7.44ZM14.595,15.444c0-.67.543-1.213,1.213-1.213s1.213.543,1.213,1.213-.543,1.212-1.213,1.212-1.213-.543-1.213-1.212Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTrain);
export default __webpack_public_path__ + "static/media/map-train.ca272f78daf504ee47a7201f14cdf216.svg";
export { ForwardRef as ReactComponent };